import { Box } from '@mui/material';

export default function AuthStepTransition({ stepKey, children }: { stepKey: string; children: React.ReactNode }) {
  return (
    <Box
      key={stepKey}
      sx={{
        animation: 'authStepIn 0.32s ease-out',
        '@keyframes authStepIn': {
          from: { opacity: 0, transform: 'translateY(8px)' },
          to: { opacity: 1, transform: 'translateY(0)' },
        },
      }}
    >
      {children}
    </Box>
  );
}
